import en from './about.en.json';
import ru from './about.ru.json';
import zh from './about.zh.json';
import es from './about.es.json';
import de from './about.de.json';
import fr from './about.fr.json';
import ja from './about.ja.json';
import hi from './about.hi.json';
import pt from './about.pt.json';
import ko from './about.ko.json';
import it from './about.it.json';
import kk from './about.kk.json';

export const aboutTranslations = {
  en,
  ru,
  zh,
  es,
  de,
  fr,
  ja,
  hi,
  pt,
  ko,
  it,
  kk,
};
